var _g;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
class IconBankLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconBank",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _g || (_g = _jsxs("g", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        stroke: "none",
        strokeWidth: "1",
        children: [_jsx("path", {
          d: "M517.334 0V638.23H624.001V106.372H1493.33V638.23L1493.33 640L1497.99 639.557L1600 640V638.23V0H517.334Z"
        }), _jsx("path", {
          d: "M0 212.743H410.667V319.447H107V1759.94C107 1789.39 131.074 1813.3 160.499 1813.3H1552.99C1578.35 1813.3 1600.39 1795.26 1605.42 1770.4L1789.35 852.965H595.872L340.25 1669.14L238.065 1637.34L517.334 746.261H1920L1710.39 1791.32C1695.41 1865.9 1629.18 1920 1552.99 1920H160.499C72.0107 1920 0 1848.19 0 1759.94V212.743Z"
        }), _jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M693.333 425.486C693.333 337.365 764.968 265.929 853.333 265.929C941.699 265.929 1013.33 337.365 1013.33 425.486C1013.33 513.607 941.699 585.044 853.333 585.044C764.968 585.044 693.333 513.607 693.333 425.486ZM853.333 372.301C823.878 372.301 800 396.113 800 425.486C800 454.86 823.878 478.672 853.333 478.672C882.788 478.672 906.667 454.86 906.667 425.486C906.667 396.113 882.788 372.301 853.333 372.301Z"
        }), _jsx("path", {
          d: "M1386.67 372.301H1120V478.672H1386.67V372.301Z"
        })]
      }))
    });
  }
}
IconBankLine.glyphName = 'bank';
IconBankLine.variant = 'Line';
IconBankLine.displayName = 'IconBankLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconBankLine.propTypes = {
  ...SVGIcon.propTypes
};
IconBankLine.allowedProps = [...SVGIcon.allowedProps];
export default IconBankLine;
export { IconBankLine };